const updateLazyLoading = (prevState, action) => {
  const treeState = prevState[action.treeId];
  const {
    plugins: { lazyLoading },
  } = action;

  if (!lazyLoading) {
    return prevState;
  }

  return {
    ...prevState,
    [action.treeId]: lazyLoading.handleUpdateLazyLoading(treeState, action),
  };
};
export default updateLazyLoading;
